// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","autocomplete":"_3jE8Vq1TKBt8aatoezqF_a","errorText":"koTOyubHhmNrbE7DtVY4B","successText":"_3O_mu6vHnMXpIVKSRWgl_f"};